export default __webpack_public_path__ + "static/shakthi-0fe2d828eac2e6cf2d859012b26db07d.png";